export interface U3141UseFetchAnnotatedLotChainIndexPdfHandlersParams {
  doFetchFn: (
    masterLotChainId: string,
    childLotChainId: string
  ) => Promise<{ data: { id?: string; status?: string; result?: { id?: string; status?: string } } }>;
  onSuccess?: (jobId: string) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseFetchAnnotatedLotChainIndexPdfHandlersReturn {
  fetchAnnotatedLotChainIndexPdf: (masterLotChainId: string, childLotChainId: string) => Promise<void>;
}

/**
 * Handlers pour la fusion des index PDF de la chaîne annotée (job asynchrone).
 * Aligné sur useU3141UseFetchPropertyIndexHandlers.
 */
export function useU3141UseFetchAnnotatedLotChainIndexPdfHandlers({
  doFetchFn,
  onSuccess,
  onError,
}: U3141UseFetchAnnotatedLotChainIndexPdfHandlersParams): U3141UseFetchAnnotatedLotChainIndexPdfHandlersReturn {
  const fetchAnnotatedLotChainIndexPdf = async (masterLotChainId: string, childLotChainId: string) => {
    try {
      const response = await doFetchFn(masterLotChainId, childLotChainId);
      const data = response?.data as Record<string, unknown> | undefined;
      const result = (data?.result ?? data?.data) as Record<string, unknown> | undefined;
      const rawId = data?.id ?? result?.id;
      const jobId = typeof rawId === "string" ? rawId : "";

      onSuccess?.(jobId);
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { fetchAnnotatedLotChainIndexPdf };
}
